<div>
  <ion-row
    data-cy="order-insight-data-row"
    class="section-data-row"
    [ngClass]="isDyfNotOrderedProduct === true ? 'red-border' : 'green-border'"
  >
    <ion-col data-cy="order-insight-data-column" offset="0.25" size="7">
      <div class="column-container">
        <div class="image-container">
          <img
            src="{{ thumbnailImageURL }}"
            data-cy="order-insight-product-image"
            (error)="
              this.thumbnailImageURL =
                getAlternativeThumbnail(thumbnailImageURL)
            "
          />
          <ion-icon
            *ngIf="!thumbnailImageURL"
            data-cy="product-card-no-image-icon"
            class="no-image"
            name="restaurant"
          ></ion-icon>
        </div>
        <div class="product-card-column">
          <div data-cy="'product-brand-name" class="brand-row">
            {{ product?.summary?.brand | acronymTitleCase }}
          </div>
          <div
            data-cy="product-description-text"
            class="description-row"
            (click)="handleProductCardClick($event)"
          >
            {{ product?.summary?.productDescTxtl | acronymTitleCase }}
          </div>

          <div class="number-salespack-row">
            <p>#{{ product?.productNumber }}</p>
            <img
              data-cy="product-card-separator-image"
              src="assets/images/separator.png"
            />
            <p>
              {{ product?.summary?.salesPackSize }}
            </p>
            <img
              data-cy="product-card-separator-image"
              src="assets/images/separator.png"
            />
            <p>
              <ng-container
                *ngIf="isDyfNotOrderedProduct; else isNewlyOrderedProduct"
              >
                <div data-cy="order-insight-date" class="product-info">
                  {{ 'i18n.orderInsightsPage.lastOrder' | translate }}
                  {{
                    !!lastOrderedDate
                      ? (lastOrderedDate | date: 'M/d' : 'GMT')
                      : '-'
                  }}
                </div>
              </ng-container>
              <ng-template #isNewlyOrderedProduct>
                <div data-cy="order-insight-quantity" class="product-info">
                  {{ lastOrderedQuantity }}
                </div>
              </ng-template>
            </p>
          </div>
          <div *ngIf="!newProductOrdered" class="tags">
            <app-usf-product-tag-list
              [tagList]="product?.productTags"
              [infoIconEnabled]="false"
              [allTagsClickable]="true"
              [product]="transformProductToProductDetail()"
              [maxTags]="3"
              data-cy="order-insights-lost-line-pills-desktop"
            >
            </app-usf-product-tag-list>
          </div>
        </div>
      </div>
    </ion-col>
    <ion-col
      data-cy="order-insight-data-column"
      class="qty-col"
      size="4"
      *appShowSplit="[lostLineAddToOrderFeatureFlag]"
    >
      <ng-container *ngIf="!newProductOrdered">
        <div class="qty-input-wrapper">
          <app-quantity-input
            [platform]="platformService?.platformType"
            [productNumber]="product?.productNumber"
            [quantity]="
              orderItems?.entities[product?.productNumber]?.unitsOrdered
            "
            [isDisabled]="
              (!isOnline && false === (offlineQtyBoxEnableFlag$ | async)) ||
              product?.summary?.properties?.has(propertiesEnum.specialOrder) ||
              !product?.orderable ||
              product?.notFound
            "
            [isProductCard]="true"
            [isEaches]="false"
            (quantityUpdateEmitter)="changeQuantityHandler($event)"
          ></app-quantity-input>

          <div>
            {{ product?.pricing?.unitPrice | currency }}
            CS
          </div>
        </div>
        <div
          *ngIf="product?.summary?.breakable && !product?.notFound"
          class="qty-input-wrapper"
        >
          <app-quantity-input
            [platform]="platformService?.platformType"
            [productNumber]="product?.productNumber"
            [quantity]="
              orderItems?.entities[product?.productNumber]?.eachesOrdered
            "
            [isDisabled]="
              (!isOnline && false === (offlineQtyBoxEnableFlag$ | async)) ||
              product?.summary?.properties?.has(propertiesEnum.specialOrder) ||
              !product?.orderable ||
              product?.notFound
            "
            [isProductCard]="true"
            [isEaches]="true"
            (quantityUpdateEmitter)="changeQuantityHandler($event)"
          ></app-quantity-input>
          <div>
            {{ product?.pricing?.eachPrice | currency }}
            EA
          </div>
        </div>
      </ng-container>
    </ion-col>
  </ion-row>
</div>
